<template>
  <section class="shared-mailbaser-senders" aria-label="MailBaser senders">
    <h2>MailBaser senders</h2>
    <p>Your existing sender connections, managed in MailBaser.</p>
    <p v-if="loading" role="status">Loading senders…</p>
    <div v-else-if="error" role="alert"><p>{{ error }}</p><button type="button" @click="load">Try again</button></div>
    <p v-else-if="!senders.length">No MailBaser senders found for your shared account.</p>
    <article v-for="sender in senders" :key="sender.workspaceId + ':' + sender.id">
      <div><h3>{{ sender.name }}</h3><p class="sender-email">{{ sender.email }}</p><p>{{ sender.provider }} · {{ sender.workspaceName }}</p><p class="sender-email">Reply to: {{ sender.replyToEmail || sender.email }}</p><p>{{ sender.verificationNote }}</p></div>
      <div class="sender-action"><span>{{ !sender.canSend ? 'Needs attention' : isLinked(sender) ? 'Linked' : 'Ready to send' }}</span><button type="button" :disabled="!sender.canSend || !!linking" @click="linkSender(sender)">{{ linking === senderKey(sender) ? 'Linking…' : isLinked(sender) ? 'Refresh link' : 'Use in GrooveMail' }}</button></div>
    </article>
    <p v-if="linkError" role="alert">{{ linkError }}</p>
    <p>Link a sender to select it in your GrooveMail emails. Provider credentials and verification stay in MailBaser.</p>
    <a href="https://mailbaser.com/sender-settings/email" target="_blank" rel="noopener noreferrer">Manage in MailBaser</a>
  </section>
</template>
<script>
import { getData, postData } from '@/utils/apiHelper';
export default {
  name: 'SharedMailBaserSenders',
  data() { return { senders: [], loading: false, error: '', linking: '', linked: [], linkError: '' }; },
  mounted() { this.load(); },
  methods: {
    senderKey(sender) { return `${sender.workspaceId}:${sender.id}`; },
    isLinked(sender) { return this.linked.includes(this.senderKey(sender)); },
    async linkSender(sender) {
      this.linking = this.senderKey(sender); this.linkError = '';
      try {
        await postData('/shared-senders/link', { workspaceId: sender.workspaceId, senderId: sender.id }, { handlesServerError: true }, true);
        this.linked.push(this.senderKey(sender));
        this.$emit('linked');
      } catch (error) {
        this.linkError = 'Could not link this sender. Check its availability and your workspace access in MailBaser, then try again.';
      } finally { this.linking = ''; }
    },
    async load() {
      this.loading = true; this.error = '';
      try { const response = await getData('/shared-senders/catalog', { handlesServerError: true }, true); this.senders = response.data.senders || []; this.linked = (response.data.linked || []).map(item => `${item.workspaceId}:${item.senderId}`); }
      catch (error) { this.error = 'MailBaser senders are unavailable. Check your shared account or ask your administrator to enable shared sending.'; }
      finally { this.loading = false; }
    }
  }
};
</script>
<style scoped>
.shared-mailbaser-senders { padding: 24px; border: 1px solid var(--gm-border-color, #e2e8f0); border-radius: 12px; }
h2, h3 { font-weight: 600; } h2 { font-size: 18px; } p { margin: 6px 0; }
article { display: flex; flex-direction: column; flex-wrap: wrap; justify-content: space-between; gap: 12px; padding: 16px 0; border-bottom: 1px solid var(--gm-border-color, #e2e8f0); }
article > div { min-width: 0; flex: 1; } .sender-email { overflow-wrap: anywhere; }
.sender-action { display: flex; flex-direction: column; align-items: flex-start; }
.sender-action button { min-height: 40px; padding: 8px 12px; border: 1px solid var(--gm-border-color, #e2e8f0); border-radius: 6px; background: transparent; font: inherit; text-decoration: none; cursor: pointer; }
button:disabled { opacity: .6; cursor: default; text-decoration: none; }
a, button { display: inline-block; margin-top: 12px; text-decoration: underline; }
@media (min-width: 640px) { article { flex-direction: row; } }
</style>
